module.exports = __webpack_public_path__ + "img/0-121.c54be33b.jpg";